import React from "react";
import { Box } from "@mui/material";
import { ComponentType } from "@growth-machine-llc/stridist-api-client";
import { AddedLozenge } from "../item/AddedLozenge";
import clsx from "clsx";
import { exerciseLibraryStyles } from "../exercise-library/exerciseLibraryStyles";
import { capitalize } from "lodash";

export interface ComponentTemplateCategoryBadgeProps {
  category: ComponentType;
  classes?: Partial<Record<"badge" | "category", string>>;
}

export const ComponentTemplateCategoryBadge: React.FC<
  ComponentTemplateCategoryBadgeProps
> = ({ category, classes }) => {
  const s = exerciseLibraryStyles();

  return (
    <>
      <Box component="span" sx={{ display: "inline-block" }}>
        <AddedLozenge
          sx={{ "&.MuiBox-root": { m: 0 }, width: "fit-content" }}
          className={clsx(s.badgeCategoryTag, classes?.category)}
          text={capitalize(category)}
        />
      </Box>
    </>
  );
};
